import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { inject, Injectable, Signal } from '@angular/core';
import { ObrebAppEntityDictionaryObreb, ObrebService } from '../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class ParcelItemForm extends AppForm {

  private obrebService: ObrebService = inject(ObrebService);

  public obrebList: Signal<ObrebAppEntityDictionaryObreb[] | undefined> = toSignal(this.obrebService.getObrebCollectionObrebCollection({
    pagination: false,
    orderName: 'asc'
  }));

  constructor() {
    super({
      precinct: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      registrationNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      municipality: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
  }

  public precinctChange(v: string): void {
    const gmina = this.obrebList()?.filter(item => item.name === v)[0]?.gmina?.name;
    if (!!gmina && !this.municipality.value?.length) {
      this.municipality.setValue(gmina);
    }
  }

  public get municipality(): FormControl {
    return this.get('municipality') as FormControl;
  }

  public get precinct(): FormControl {
    return this.get('precinct') as FormControl;
  }

  public get registrationNumber(): FormControl {
    return this.get('registrationNumber') as FormControl;
  }
}
